import { render } from "./EmptyIcon.vue?vue&type=template&id=e665adc2"
import script from "./EmptyIcon.vue?vue&type=script&lang=js"
export * from "./EmptyIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__